export enum SortDirection {
	ASCENDING = "ASCENDING",
	DESCENDING = "DESCENDING",
}
